<!-- No Workout Empty State Template -->

<!-- Skipped Workout State Template -->
<ng-template #skippedWorkoutTemplate let-slotData="slotData">
  <div class="skipped-workout-message">
    <div class="empty-state-content">
      <cs-icon name="exercise"></cs-icon>
      <div class="empty-state-text">
        <div class="empty-state-title">{{ LL.common.states.skipped() }}</div>
        <div class="empty-state-subtitle" [class.invisible]="!slotData.nextWorkoutDateLabel">
          {{ LL.dayItems.skippedWorkout.message({ date: slotData.nextWorkoutDateLabel }) }}
        </div>
      </div>
    </div>
    <cs-button [class.invisible]="!canRevertSkip" secondary small (click)="revertSkipWorkoutAsync()">
      {{ LL.dayItems.skippedWorkout.moveToTodayButton() }}
    </cs-button>
  </div>
</ng-template>

<!-- One day's body, drawn into both day slots (A and B) below. The page keeps two
     copies of a day so it can slide between them; writing the body once here keeps
     the two copies identical. -->
<ng-template #dayBodyTemplate let-slotData="slotData">
  <!-- Exercise List (held off the DOM until the page-enter slide finishes — see contentEntered) -->
  @if (contentEntered && slotData.logWorkout && slotData.logWorkout.state !== 'Skipped') {
    <!-- #4142 review fixes: the badges match the workout page's while the compact switch is on -->
    <cs-exercise-list [exercises]="slotData.exercises" [fillCompletedBadge]="compactFeedback"
      [foldable]="false" (exerciseMoreOptionsClick)="onExerciseMoreOptions($event)"
      (exerciseHeaderClick)="onExerciseHeaderClick($event)">
      <ng-container header-cards>
        @if (slotData.showPendingWorkoutWarning && slotData.pendingWorkoutDateLabel) {
          <cs-info-card type="warning"
            [dismissible]="true" (dismissed)="onPendingWorkoutWarningDismissed()">
            {{ LL.dayItems.warnings.pendingWorkout() }} <button class="link" (click)="navigateToPendingWorkoutDay()">{{
            slotData.pendingWorkoutDateLabel }}</button>.
          </cs-info-card>
        }
        @if (slotData.showWorkoutChangedInfo) {
          <cs-info-card type="info" [dismissible]="true"
            (dismissed)="onWorkoutChangedInfoDismissed()">
            {{ LL.training.workoutChangedInfo() }}
          </cs-info-card>
        }
        @if (slotData.emptyProgramDay) {
          <cs-info-card type="info" [dismissible]="false">
            {{ LL.training.emptyProgramDay.message() }} <button class="link" (click)="openEditWorkoutsForEmptyDay(slotData)">{{
            LL.training.emptyProgramDay.editLink() }}</button>
          </cs-info-card>
        }
      </ng-container>
    </cs-exercise-list>
  }

  <!-- Skipped Workout Message -->
  @if (slotData.logWorkout?.state === 'Skipped' && !slotData.loading) {
    <ng-container *ngTemplateOutlet="skippedWorkoutTemplate; context: { slotData: slotData }"></ng-container>
  }

  <!-- No Workout Message -->
  @if (!slotData.logWorkout && !slotData.loading) {
    <div class="no-workout-message">
      <div class="empty-state-content">
        <cs-icon name="exercise"></cs-icon>
        <div class="empty-state-text">
          <div class="empty-state-title">{{ slotData.nextWorkoutDayName ? LL.training.nextWorkoutOn({ day: slotData.nextWorkoutDayName }) : LL.training.noWorkoutScheduled() }}</div>
          <div class="empty-state-subtitle" [class.invisible]="!canStartWorkout">{{ LL.training.trainAnyway() }}
          </div>
        </div>
      </div>
      <cs-button [class.invisible]="!canStartWorkout" primary small (click)="startWorkout()">
        {{ LL.training.trainToday() }}
      </cs-button>
    </div>
  }
</ng-template>

<cs-header hideType="auto">
  <cs-header-title large>
    <span class="clickable-title" (click)="onTitleClick()">
      <span>{{ currentDayLabel }}</span>
      <cs-icon large name="arrow-point-down"></cs-icon>
    </span>
  </cs-header-title>
  <cs-icon-button header-right icon="settings" large (click)="handleSettingsButtonClicked($event)"></cs-icon-button>
  <cs-header-content>
    <cs-task-calendar [taskStatuses]="calendarTaskStatuses" [selectedDate]="currentDay"
      (selectedDateChange)="onCalendarDateSelected($event)">
    </cs-task-calendar>
    <div class="workout-title-section" [class.hidden]="!hasWorkout">
      <div class="workout-name" [class.strikethrough]="isSkipped">{{ workoutName }}&nbsp;
      </div>
      <cs-button class="start-workout-button" [class.invisible]="isSkipped" primary small
        (click)="startWorkout()">
        {{ workoutButtonText }}
      </cs-button>
      @if (hasWorkoutOptions) {
        <cs-icon-button icon="ellipsis-vertical" large
        (click)="showWorkoutOptions($event)"></cs-icon-button>
      }
    </div>
  </cs-header-content>
</cs-header>

<cs-tab-content-container [selection]="activeDaySlot" [animate]="animateDayContent" [isBack]="isBack"
  [swipeEnabled]="hasClientSmallScreen()" (swipeForward)="handleSwipeForward()" (swipeBack)="handleSwipeBack()">
  <!-- Day Content Slot A -->
  <cs-tab-content [value]="'A'" [rebuildLayerOnEnter]="true">
    <cs-content [loading]="slots.A.loading || !contentEntered">
      <ng-container *ngTemplateOutlet="dayBodyTemplate; context: { slotData: slots.A }"></ng-container>
    </cs-content>
  </cs-tab-content>

  <!-- Day Content Slot B -->
  <cs-tab-content [value]="'B'" [rebuildLayerOnEnter]="true">
    <cs-content [loading]="slots.B.loading || !contentEntered">
      <ng-container *ngTemplateOutlet="dayBodyTemplate; context: { slotData: slots.B }"></ng-container>
    </cs-content>
  </cs-tab-content>
</cs-tab-content-container>

<!-- Start Workout Button (floating on mobile only) -->
<!-- <cs-page-action-buttons *ngIf="activeSlotData.hasWorkout && hasClientSmallScreen()">
<cs-button primary medium [label]="workoutButtonText" (click)="startWorkout()"></cs-button>
</cs-page-action-buttons> -->